import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Container, Header } from 'semantic-ui-react';
import { FormattedNumber } from 'react-intl';
import { isEmpty } from 'ramda';

import { ClassProp } from 'helpers/types';
import { formatDate } from 'helpers/date';
import Table from 'components/Table';
import { Renewal } from 'scenes/AccountManagement/AccountManagement.helpers';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  allRenewals: Renewal[];
};

const styles = {
  header: {
    marginTop: '2.5rem !important',
    display: 'none !important',
  },
  headerContainer: {
    padding: '2.25rem',
  },
  tableWrapper: {
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.15) !important',
    backgroundColor: '#fff',
  },
  invoiceLink: {
    fontSize: '1rem !important',
    fontWeight: '500 !important',
  },
  topWrapper: {
    padding: '2.5rem !important',
    background: '#fff !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.15) !important',
  },
  icon: {
    color: '#969696 !important',
    fontSize: '.6975rem !important',
  },
  paymentStrong: {
    fontWeight: '500 !important',
  },
  tableRow: {
    borderBottom: '.0625rem solid #e6e7e8 !important',
  },
};

const currencyOptions = {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const generateAmount = (amount: number) => (
  <span>
    <FormattedNumber value={amount / 100} {...currencyOptions} />
  </span>
);

const tableHeader = [
  {
    source: ['events', '0', 'eventLoggedAt'],
    sortable: ['events', '0', 'eventLoggedAt'],
    label: 'Date Paid',
    transform: (date: string) => formatDate(date, 'MMM DD, YYYY'),
  },
  {
    source: ['events', '0', 'renewalStatus'],
    sortable: ['events', '0', 'renewalStatus'],
    label: 'Status',
  },
  {
    source: ['monthlyPayment'],
    sortable: false,
    label: 'Amount',
    transform: (amount: number) => generateAmount(amount),
  },
];

const InvoiceDetails: FunctionComponent<Props> = ({ classes, allRenewals }) => {
  return (
    <Container>
      <h3>Billing History</h3>
      <div className={classes.tableWrapper}>
        {isEmpty(allRenewals) ? (
          <div className={classes.headerContainer}>
            <Header as="h2">No Invoices Found</Header>
          </div>
        ) : (
          <Table
            itemsKey="eventLoggedAt"
            // @ts-expect-error tableHeader
            tableHeader={tableHeader}
            data={allRenewals}
            sortDefaultColumn={{
              name: 'Date Paid',
              sortable: ['eventLoggedAt'],
            }}
          />
        )}
      </div>
    </Container>
  );
};
export default withStyles(styles)(InvoiceDetails);
